import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Field } from 'redux-form';
import get from 'lodash/get';
import browserHistory from 'react-router/lib/browserHistory';

import appendLocale from '../../helpers/appendLocale';

import * as styles from './FeedbackIncreaseLimits.scss';

class FeedbackIncreaseLimits extends Component {
  componentWillReceiveProps({ foreignLimit }) {
    if (foreignLimit.loaded && foreignLimit.loaded !== this.props.foreignLimit.loaded) {
      this.props.openMessageModal({
        message: (
          <div className="contentMessage">
            <div>
              <p>{this.props.translate('modalForeignLimit', 'messageSent')}</p>
              <button
                className="btn btn-primary"
                onClick={this.мessageModalOk}
              >
                {this.props.translate('contactUsPage', 'ok')}
              </button>
            </div>
          </div>
        ),
        isCloseButtonInvisible: true
      });
    }

    if (foreignLimit.error && foreignLimit.error !== this.props.foreignLimit.error) {
      this.props.openMessageModal({
        message: (
          <div className="contentMessage">
            <div>
              <p>{this.props.translate('modalForeignLimit', 'errorMessage')}</p>
              <button
                className="btn btn-primary"
                onClick={this.props.hideMessageModal}
              >
                {this.props.translate('contactUsPage', 'ok')}
              </button>
            </div>
          </div>
        )
      });
    }
  }

  мessageModalOk = () => {
    this.props.closeModal();
    this.props.hideMessageModal();
    browserHistory.push(appendLocale(this.props.locale, '/foreign'));
  }

  submitForm = (value) => {
    this.props.askForeignLimit({ data: value, token: this.props.userToken });
  };

  handleSubmit = (evt) => {
    this.props.handleSubmit(this.submitForm)(evt);
    return true;
  };

  renderInput = (input, meta, placeholder, disabled) => (
    <input
      {...input}
      type="text"
      disabled={disabled}
      placeholder={this.props.translate('modalForeignLimit', placeholder)}
      className={cx(styles.inputNumb, styles.numeric, 'form-control',
        { not_valid: meta.touched && meta.error && !meta.active })}
    />
  );

  renderNameInput = ({ input, meta }) =>
    this.renderInput({ ...input }, meta, 'name', get(this.props, 'userData.display_name', false));
  renderEmailInput = ({ input, meta }) =>
    this.renderInput({ ...input }, meta, 'email', get(this.props, 'userData.email', false));
  renderPhoneNumberInput = ({ input, meta }) => this.renderInput({ ...input }, meta, 'phoneNumber');
  renderMessageInput = ({ input, meta }) => this.renderInput({ ...input }, meta, 'message');

  renderForm = () => (
    <div className={styles.formWrapper}>
        <div className={styles.formRow}>
            <span className={styles.label}>
                {this.props.translate('modalForeignLimit', 'name')}
                <span className="req">*</span>
            </span>
            <div className={styles.content}>
            <Field
              name="name"
              locale={this.props.locale}
              component={this.renderNameInput}
            />
            </div>
        </div>
        <div className={styles.block}>
            <div className={styles.formRow}>
                <span className={styles.label}>
                    {this.props.translate('modalForeignLimit', 'phoneNumber')}
                    <span className="req">*</span>
                </span>
                <div className={styles.content}>
                <Field
                  name="phone_number"
                  locale={this.props.locale}
                  component={this.renderPhoneNumberInput}
                />
                </div>
            </div>
            <div className={styles.formRow}>
                <span className={styles.label}>
                    {this.props.translate('modalForeignLimit', 'email')}
                    <span className="req">*</span>
                </span>
                <div className={styles.content}>
                <Field
                  name="email"
                  locale={this.props.locale}
                  component={this.renderEmailInput}
                />
                </div>
            </div>
        </div>
        <div className={styles.formRow}>
            <span className={styles.label}>
                {this.props.translate('modalForeignLimit', 'message')}
                <span className="req">*</span>
            </span>
            <div className={styles.content}>
            <Field
              name="message"
              locale={this.props.locale}
              component={this.renderMessageInput}
            />
            </div>
        </div>
    </div>
  );

  render() {
    const {
      closeModal,
      foreignLimit,
      translate,
      isPackageUpdate,
      withoutSubtitle
    } = this.props;
    const isPublishForeign = get(this.props, 'userData.publish_permissions.foreign', null);

    return (
      <div className={styles.container}>
        <span
          className={styles.close}
          onClick={closeModal}
        >
          <i className="icon icon-close" />
        </span>
        <p className={styles.title}>
          {!isPackageUpdate
            ? translate('modalForeignLimit', isPublishForeign ? 'title' : 'regularTitle')
            : translate('modalForeignLimit', 'packageUpdateTitle')
          }
        </p>
        {!withoutSubtitle &&
          <p className={styles.subtitle}>
            {isPublishForeign
              ? translate('modalForeignLimit', 'subtitle')
              : translate('modalForeignLimit', 'regularSubtitle')
            }
          </p>
        }
        <form>
          {this.renderForm()}
        </form>
        <div className={styles.submitWrapper}>
          <button
            onClick={this.handleSubmit}
            disabled={(foreignLimit.loading)}
          >
            {foreignLimit.loading
              ? <i className={cx('icon icon-om-spinner om-pulse', 'spinner')} />
              : (<span className="button-text">{translate('modalForeignLimit', 'send')}</span>)
            }
          </button>
        </div>
      </div>
    );
  }
}

FeedbackIncreaseLimits.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string,
  openMessageModal: PropTypes.func,
  hideMessageModal: PropTypes.func,
  isMessageModalOpen: PropTypes.bool,
  isPackageUpdate: PropTypes.bool,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  userData: PropTypes.object,
  closeModal: PropTypes.func,
  askForeignLimit: PropTypes.func,
  foreignLimit: PropTypes.object,
  userToken: PropTypes.string,
  fields: PropTypes.object,
  withoutSubtitle: PropTypes.bool
};

export default FeedbackIncreaseLimits;
